import { KeyboardEvent } from 'react';

export function handleKeyboardActivation(e: KeyboardEvent, action: () => void) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    action();
  }
}
